function HeaderHelper() {
  this.header = document.querySelector('header.main-header');

  this.setGlobals = () => {
    document.body.style.setProperty(
    	'--header-height',
    	`${this.header.getBoundingClientRect().height}px`
    );

    document.body.style.setProperty(
    	'--window-height',
    	`${window.innerHeight}px`
    );
  }

  return this;
}

export default new HeaderHelper();
